module.exports = require('./modules/components/Route');



//////////////////
// WEBPACK FOOTER
// ./~/react-router/Route.js
// module id = 208
// module chunks = 0